/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$(function(){

  faqShowMore();
  productDescTabs();
  subscriptionOptionChange();
  
});

function faqShowMore() {
  $(document).on("click", ".whims-faq .see-more-faq", function (e) {
    e.preventDefault();
    if ($(this).hasClass("open")) {
      $(this).text("See more");
      var elHeight =  $(".whims-faq").offset().top - 50;
      $("html, body").animate({ scrollTop: elHeight},450);
     $(".whims-faq .Whims-faq-wrapper .mb-hide-more").removeAttr('style');
    } else {
      $(this).text("See less");
      $(".whims-faq .Whims-faq-wrapper .mb-hide-more").slideDown(350);
    }
    $(this).toggleClass("open");
  });
}

function productDescTabs() {
 $('ul.tabs').each(function(){
   var active, content, links = $(this).find('a');
   active = links.first().addClass('active');
   content = $(active.attr('href'));
   links.not(':first').each(function () {
     $($(this).attr('href')).hide();
   });
   $(this).find('a').click(function(e){
     active.removeClass('active');
     content.hide();
     active = $(this);
     content = $($(this).attr('href'));
     active.addClass('active');
     content.show();
     return false;
   });
 });
}

function subscriptionOptionChange() {
  //on styleselect div click
  $('[data-widget-container] .styledSelect').on('click', function (e) {
    e.stopPropagation();
    if($(this).hasClass('active')){
      $(this).removeClass('active');
      $(this).next('ul.options').hide();
    }else {
      $(this).addClass('active');
      $(this).next('ul.options').show();
    }
  });

  //on ul > li click
  $('[data-widget-container] .select').find('.options li').on('click',function (e) {
    e.stopPropagation();
    var sellingPlanId = $(this).attr('value');
    $(this).closest('[data-widget-container]').find('.styledSelect').attr('data-selling-id',sellingPlanId);
    $(this).closest('form.ProductForm').find('input[name="selling_plan"]').attr('value',sellingPlanId);
    $(this).closest('[data-widget-container]').find('.styledSelect').text($(this).text()).removeClass('active');
    $('[data-widget-container] .select .options li').removeClass('selected-opt');
    $(this).addClass('selected-opt');
    $(this).parent().hide();
  });

  //on recharge option change
  $('[data-widget-container] input[name="selling_plan_select"]').on('change',function(e){
    e.stopPropagation();
    if($(this).val() == 'onetime'){
      $(this).closest('form.ProductForm').find('input[name="selling_plan"]').attr('value','');
      $(this).closest('[data-template-legacy-radio]').find('.rc-legacy-radio[data-option-subsave]').find('input[name="selling_plan_select"]').prop('checked',false);
      $(this).closest('[data-template-legacy-radio]').find('.rc-legacy-radio[data-option-subsave]').removeClass('rc-option--active');
      let ontimePriceTxt = $(this).closest('[data-template-legacy-radio]').find('.rc-legacy-radio[data-option-onetime]').find('[data-price-onetime]').text();
      $('.Product__Info  .ProductMeta__PriceList .price--regular').text(ontimePriceTxt);
      $('.Product__Info  button[data-action="add-to-cart"] .price-in-button').text(ontimePriceTxt);
    }else{
      var selectedSellingPlanId = $(this).closest('[data-widget-container]').find('.styledSelect').attr('data-selling-id');
      $(this).closest('form.ProductForm').find('input[name="selling_plan"]').attr('value',selectedSellingPlanId);
      $(this).closest('[data-template-legacy-radio]').find('.rc-legacy-radio[data-option-onetime]').find('input[name="selling_plan_select"]').prop('checked',false);
      $(this).closest('[data-template-legacy-radio]').find('.rc-legacy-radio[data-option-onetime]').removeClass('rc-option--active');
      let subPriceTxt = $(this).closest('[data-template-legacy-radio]').find('.rc-legacy-radio[data-option-subsave]').find('[data-price-subsave]').text();
      $('.Product__Info  .ProductMeta__PriceList .price--regular').text(subPriceTxt);
      $('.Product__Info  button[data-action="add-to-cart"] .price-in-button').text(subPriceTxt);
    }
    $(this).closest('.rc-legacy-radio').addClass('rc-option--active');
    $(this).prop('checked',true);
  });
}


// This will only render in the theme editor
if (Shopify.designMode) {
  
  document.addEventListener('shopify:section:load', function(){
   const mianProductContainer = event.target.closest('.main--product') || null;
    if(mianProductContainer){
      productDescTabs();
      subscriptionOptionChange();
    }
  });
  
}